// extracted by mini-css-extract-plugin
module.exports = {"body":"body--5kpQh","listItem":"listItem--26AS5","label":"label--35tQk"};